import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Component to display after successful creation of a password
 */
const PasswordCreated: React.FC = () => {
  const { t } = useCustomTranslation()
  const navigate = useNavigate()

  return (
    <Grid
      container
      sx={theme => ({
        marginTop: theme.spacing(2),
      })}
    >
      <Grid item xs={12}>
        <Typography
          variant="h5"
          sx={theme => ({ marginBottom: theme.spacing(3), textAlign: 'center', fontWeight: theme.typography.fontWeightRegular })}
        >
          {t('shell.register.invitation.success')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" fullWidth onClick={() => navigate('/login')}>
          {t('common.toLogin')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default PasswordCreated
